import { Theme } from '@desygner/ui-common-components';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import styled, { css } from 'styled-components';

import { constants } from '@config';
import translate from '@translations';
import Icon from 'src/UI/Icon/Icon';

const tooltipText = {
  linked: translate('text_overflow.tooltip_linked'),
  notLinked: translate('text_overflow.tooltip_not_linked')
};

const RightArrowIcon = () => <Icon
  name='arrow-upload'
  angle={90}
  color={Theme.Color.System.Primary}
/>;

const CrossIcon = () => <Icon
  name='cross'
  color='#fff'
/>;

const LinkButton = styled.div`
  font-size: 13px;
  z-index: 1;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  background: ${({ isLinked, theme }) => isLinked ? theme.Color.System.Primary : '#fff'};
  box-shadow: ${({ isLinked, theme }) => isLinked ? 'none' : `inset 0px 0px 0px 1px ${theme.Color.Neutrals.Border}`};
  cursor:  ${({ isLinked }) => isLinked ? 'grab' : 'crosshair'};
  position: absolute;
  opacity: ${({ isDragging }) => isDragging ? 0.4 : 1};

  ${({ isLeft, borderWidth, size, offset }) => {
    const left = (borderWidth - size) / 2;
    const top = offset - (size / 2);

    return isLeft
      ? css`left: ${left}px; top: ${top}px;`
      : css`right: ${left}px; bottom: ${top}px;`;
  }}

  > i {
    opacity: ${({ isLinked }) => isLinked ? 0 : 1};
  }

  :active {
    cursor: grabbing;
  }

  :hover {
    background: ${({ theme }) => theme.Color.System.Primary};
    box-shadow: none;

    > i {
      opacity: ${({ isLinked }) => isLinked ? 1 : 0};
    }
  }
`;

function TextOverflowButton ({ position, isLinked, size = 18, borderWidth = 2, offset = constants.text.textOverflowButtonOffset }) {
  const ButtonIcon = isLinked ? CrossIcon : RightArrowIcon;

  const isLeft = position === 'left';

  return (
    <LinkButton
      draggable
      size={size}
      borderWidth={borderWidth}
      offset={offset}
      isLeft={isLeft}
      isLinked={isLinked}
      className={isLeft ? 'prev-link-button' : 'next-link-button'}
      data-tip={isLinked ? tooltipText.linked : tooltipText.notLinked}
    >
      <ButtonIcon />
    </LinkButton>
  );
}

TextOverflowButton.propTypes = {
  position: PropTypes.string,
  isLinked: PropTypes.bool,
  size: PropTypes.number,
  offset: PropTypes.number,
  borderWidth: PropTypes.number
};

export default memo(TextOverflowButton);
